import axios from "./index";

export default {
  getAll() {
    return axios.get("/v1/setting/festivals");
  },
  getDropdown() {
    return axios.get("/v1/setting/festivals/dropdown");
  },
  create(data) {
    return axios.post("/v1/setting/festivals", data);
  },
  update(uuid, data) {
    return axios.patch(`/v1/setting/festivals/${uuid}`, data);
  },
};
